module.exports = __webpack_public_path__ + "static/media/friend-plus.fa6b5e69.png";